import { Controller } from "stimulus"

// Toggles the "after_save" choice on the AI task wizard final step.
// Shows inline schedule options when user selects Schedule.
export default class extends Controller {
  static targets = ["scheduleOptions"]

  selectRunNow(event) {
    this.setChoice(event.currentTarget, "run_now")
    if (this.hasScheduleOptionsTarget) this.scheduleOptionsTarget.classList.add("d-none")
  }

  selectRunAnytime(event) {
    this.setChoice(event.currentTarget, "run_anytime")
    if (this.hasScheduleOptionsTarget) this.scheduleOptionsTarget.classList.add("d-none")
  }

  selectSchedule(event) {
    this.setChoice(event.currentTarget, "schedule")
    if (this.hasScheduleOptionsTarget) this.scheduleOptionsTarget.classList.remove("d-none")
  }

  setChoice(card, value) {
    const field = document.getElementById("after-save-field")
    if (field) field.value = value

    // Visual toggle
    this.element.querySelectorAll(".task-choice-card").forEach(c => {
      c.classList.remove("selected")
    })
    card.classList.add("selected")
  }
}
